export const setActiveSubscription = (activeSubscription) => ({
  type: "SET_ACTIVE_SUBSCRIPTION",
  payload: activeSubscription,
});

export const fetchActiveSubscription = (token) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  return async (dispatch) => {
    try {
      const response = await fetch(`${apiUrl}/api/subscriptions/active`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Erreur lors du chargement de la souscription active");
      }

      dispatch(setActiveSubscription(data.activeSubscription));
      return data.activeSubscription;
    } catch (error) {
      console.error("Erreur fetchActiveSubscription:", error);
      throw error;
    }
  };
};
